module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-light-300.woff?18413bddcf6208625693dc5e082c7635";